import { Chakra } from "@airhelp/react-ui-components";
import type { ReactNode } from "react";
import { capitalizedHeading } from "components/Heading";
import type { HeadingProps } from "./Heading.d";
import { createHeadingId } from "../../utils";

const { Heading: ChakraHeading } = Chakra;

const Heading = ({ variant, children, styles, as }: HeadingProps) => {
  const isCapitalizedHeading = variant === "capitals";
  const headingProps = isCapitalizedHeading ? { sx: styles, ...capitalizedHeading } : { sx: styles };

  return (
    <ChakraHeading
      as={as}
      id={createHeadingId(children as string[] | string | ReactNode[])}
      variant={variant}
      {...headingProps}
    >
      {children}
    </ChakraHeading>
  );
};

export default Heading;
